// extracted by mini-css-extract-plugin
export default {"container":"index_container__VttqT","endorsers":"index_endorsers__adYue","page-header":"index_page-header__UFj+b"};